<div class="relative">
  <button type="button"
    class="relative flex h-10 w-10 items-center justify-center rounded-full text-brand-navy transition-colors hover:bg-brand-sand focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange-300 focus-visible:ring-offset-2 focus-visible:ring-offset-white"
    (click)="toggle()" aria-label="Notificaciones">
    <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9">
      </path>
    </svg>
    <span *ngIf="unreadCount() > 0"
      class="absolute top-1 right-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-500 px-1 text-xs font-bold text-white">
      {{ unreadCount() > 99 ? '99+' : unreadCount() }}
    </span>
  </button>

  <div *ngIf="isOpen()"
    class="absolute right-0 top-12 z-50 w-80 max-h-[32rem] overflow-y-auto rounded-xl border border-gray-200 bg-white shadow-lg">
    <div class="sticky top-0 border-b border-gray-200 bg-white px-4 py-3">
      <p class="font-futura-bold text-base text-gray-900">Notificaciones</p>
    </div>

    <ng-container *ngIf="visibleNotifications().length > 0; else emptyState">
      <ul class="divide-y divide-gray-100">
        <li *ngFor="let notification of visibleNotifications(); trackBy: trackByUid"
          class="cursor-pointer px-4 py-3 transition-colors hover:bg-gray-50" [class.bg-blue-50]="!notification.read"
          (click)="goto(notification)">
          <div class="flex items-start gap-3">
            <div class="flex-shrink-0">
              <img *ngIf="notification.image; else iconBlock" [src]="notification.image" [alt]="notification.title"
                class="h-10 w-10 rounded-full object-cover" />
              <ng-template #iconBlock>
                <div class="flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-gray-500">
                  <svg *ngIf="!notification.icon" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                    stroke-width="2" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z"></path>
                  </svg>
                  <!-- not working with icon -->
                  <!-- <img
                    *ngIf="notification.icon"
                    [src]="notification.icon"
                    [alt]="notification.title"
                    class="h-6 w-6 object-contain"
                  /> -->
                </div>
              </ng-template>
            </div>
            <div class="min-w-0 flex-1">
              <p class="font-futura-bold text-sm text-gray-900">{{ notification.title }}</p>
              <p class="mt-0.5 truncate text-sm text-gray-600">{{ notification.body }}</p>
              <p class="mt-1 text-xs text-gray-400">{{ notification.createdAt | dateAgo }}</p>
            </div>
          </div>
        </li>
      </ul>
    </ng-container>

    <ng-template #emptyState>
      <div class="px-4 py-8 text-center">
        <p class="text-sm text-gray-500">No tienes notificaciones.</p>
      </div>
    </ng-template>

    <div class="sticky bottom-0 border-t border-gray-200 bg-white px-4 py-3 text-center">
      <a routerLink="/reclutador/notificaciones" (click)="close()"
        class="font-futura-medium text-sm text-orange-600 transition-colors hover:text-orange-700">
        Ver todas
      </a>
    </div>
  </div>
</div>